import log from '@uwm/logger';

import type {UwmCommandDetail, UwmHandlerMap} from './types';

export const createCommandProcessor = (handlers: UwmHandlerMap) => {
    return (detail: UwmCommandDetail): void => {
        if (!detail?.payload || !detail.command) return;

        log.info(`[UWM] ← ${detail.command}: ${JSON.stringify(detail.payload)}`);

        const handler = handlers[detail.command];

        if (!handler) {
            log.warn(`[UWM] No handler for command: ${detail.command}`);
            return;
        }

        handler(detail.payload);
    };
};
